import { isBiUploadDeletable } from '@euler/app/components/message/widgets/bi-upload/functions/biUploadPhase';
import { useBiUploadDelete } from '@euler/app/components/message/widgets/bi-upload/functions/useBiUploadDelete';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { BiUploadStatus, BiUploadView } from '@euler/model/bi/upload';
import { FileSpreadsheet, FileWarning, Trash2 } from 'lucide-react-native';
import { memo } from 'react';
import { BiButton } from '../../components/ui/BiButton';
import { BiTag } from '../../components/ui/BiTag';
import { biTimeLabel } from '../../functions/biDashboardText';
import { biUploadStateText } from '../functions/biLibraryText';
import { LibraryTile } from './LibraryTile';

/**
 * An upload still on its way, or one that failed: it is finished in the
 * conversation it was started in.
 */
export const UploadTile = memo(
  ({ upload, onDeleted }: { upload: BiUploadView; onDeleted: () => void }) => {
    const { deleting, error, remove } = useBiUploadDelete(onDeleted);
    const failed = upload.status === BiUploadStatus.Failed;
    const ended = upload.status === BiUploadStatus.Expired;
    return (
      <LibraryTile
        icon={failed ? FileWarning : FileSpreadsheet}
        color={failed ? aiColors.destructive : aiColors.primary}
        name={upload.fileName || '表格'}
        tags={
          <BiTag
            text={failed ? '没有导入' : ended ? '已结束' : '导入中'}
            color={
              failed
                ? aiColors.destructive
                : ended
                ? aiColors.mutedForeground
                : aiColors.primary
            }
          />
        }
        tone={failed || error ? 'danger' : undefined}
        lines={[
          `上传于 ${biTimeLabel(upload.createdAt)}`,
          biUploadStateText(upload),
          failed || ended ? null : '在上传它的 AI 对话里继续',
          error,
        ]}
        action={
          isBiUploadDeletable(upload) ? (
            <BiButton
              icon={Trash2}
              tone="quiet"
              accessibilityLabel="删除这次上传"
              loading={deleting}
              onPress={() => void remove(upload)}
            />
          ) : null
        }
      />
    );
  },
);
